import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Alert } from 'react-bootstrap';
import { Heading5 } from '../../widgets';
import UserLoginCard from './UserLoginCard';

const AccessFormModal = (props) => {
    const { onHide, userInfo, providerListById, currentAuthId, isRequesting } = props;

    const [response, setResponse] = useState({
        isSuccess: false,
        message: null
    });

    const filteredList = currentAuthId ? [currentAuthId] : Object.keys(providerListById);

    return <Modal className="access-form-modal" show={true} backdrop="static" onHide={onHide} size='md'>
        <Modal.Header closeButton style={{ color: '#064d9e', border: 0 }}>
            <Modal.Title className="ml-3">
                <Heading5>
                    Oauth
                </Heading5>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2">
            {response.message && <div className="auth-form-alert">
                <Alert show={true} variant={response.isSuccess ? "success" : "danger"}
                    onClose={() => setResponse({ isSuccess: false, message: null })} dismissible>{response.message}</Alert>
            </div>}
            {isRequesting || filteredList.length === 0 ? <Row className="m-0 w-100 ">
                <span className="no-records-found">{isRequesting ? "Loading..." : "No records found"}</span></Row> :
                <Row className="m-0 w-100">
                    {filteredList.map(id => {
                        return <UserLoginCard
                            key={id}
                            authId={id}
                            userInfo={userInfo}
                            setResponse={setResponse}
                        />
                    }
                    )}
                </Row>}
        </Modal.Body>
    </Modal>
}

const mapStateToProps = (state, ownProps) => ({
    userInfo: state.users.userListById.payload[ownProps.userId],
    isRequesting: state.users.authProviderListById.isRequesting,
});

export default connect(mapStateToProps)(AccessFormModal);